import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'nombreSucursal',
})
export class NombreSucursalPipe implements PipeTransform {
  transform(args: string): string {
    if (args.toLowerCase().includes('comercio electronico')) {
      return 'Comercio Electronico';
    }
    return args;
  }
}
